import React from 'react'
import { Icon } from 'semantic-ui-react'
import Markdown from 'react-markdown'
import Popup from '@ui/Popup'

function TranslationIcon({ tooltip }) {
  return tooltip ? (
    <Popup
      triggerClassName='translate-icon-container'
      trigger={<Icon name='world' className='translate-icon' />}
      position='top left'
    >
      {<Markdown className='tooltip'>{tooltip}</Markdown>}
    </Popup>
  ) : null
}

export default TranslationIcon
